function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
import styled, { css } from "styled-components";
import getResponsiveBackgroundImageStyles from "../../../helpers/getResponsiveBackgroundImageStyles";
import breakpoint from "../../../utils/breakpoint";
import getBorderColor from "../../../utils/getBorderColor";
import getBorderRadius from "../../../utils/getBorderRadius";
import getBoxShadow from "../../../utils/getBoxShadow";
import getColor from "../../../utils/getColor";
import { getCustomColor } from "../../../utils/getCustomColor";
import space from "../../../utils/space";
import unit from "../../../utils/unit";
import { defaultProps } from "./SurfaceOrg.props";
export var spacing = {
  "default": 6,
  small: 4,
  tiny: 2
};
var spacingBaseStyles = function spacingBaseStyles(spacingSpace) {
  if (_typeof(spacingSpace) === "object" && "vertical" in spacingSpace) {
    return css(["padding:", " ", ";"], space(spacingSpace.vertical), space(spacingSpace.horizontal));
  }
  return css(["padding:", ";"], space(spacingSpace));
};
export var spacingStyles = function spacingStyles(spacingSpace) {
  if (_typeof(spacingSpace) === "object" && "small" in spacingSpace) {
    return css(["", ";", " ", ""], spacingBaseStyles(spacingSpace.small), spacingSpace.medium && css(["", "{", ";}"], breakpoint("medium"), spacingBaseStyles(spacingSpace.medium)), spacingSpace.large && css(["", "{", ";}"], breakpoint("large"), spacingBaseStyles(spacingSpace.large)));
  }
  return css(["", ";"], spacingBaseStyles(spacingSpace));
};
var borderRadiusBaseStyles = function borderRadiusBaseStyles(borderRadiusSize, theme) {
  if (_typeof(borderRadiusSize) === "object" && "topLeft" in borderRadiusSize) {
    return css(["border-radius:", " ", " ", " ", ";"], borderRadiusSize.topLeft ? getBorderRadius(theme, borderRadiusSize.topLeft) : 0, borderRadiusSize.topRight ? getBorderRadius(theme, borderRadiusSize.topRight) : 0, borderRadiusSize.bottomRight ? getBorderRadius(theme, borderRadiusSize.bottomRight) : 0, borderRadiusSize.bottomLeft ? getBorderRadius(theme, borderRadiusSize.bottomLeft) : 0);
  }
  return css(["border-radius:", ";"], getBorderRadius(theme, borderRadiusSize));
};
export var borderRadiusStyles = function borderRadiusStyles(borderRadiusSize, theme) {
  if (_typeof(borderRadiusSize) === "object" && "small" in borderRadiusSize) {
    return css(["", ";", " ", " ", ""], borderRadiusBaseStyles(borderRadiusSize.small, theme), borderRadiusSize.medium && css(["", "{", ";}"], breakpoint("medium"), borderRadiusBaseStyles(borderRadiusSize.medium, theme)), borderRadiusSize.large && css(["", "{", ";}"], breakpoint("large"), borderRadiusBaseStyles(borderRadiusSize.large, theme)), borderRadiusSize.huge && css(["", "{", ";}"], breakpoint("huge"), borderRadiusBaseStyles(borderRadiusSize.huge || borderRadiusSize.large, theme)));
  }
  return css(["", ";"], borderRadiusBaseStyles(borderRadiusSize, theme));
};
export var StyledSurfaceOrg = styled.div.withConfig({
  componentId: "sc-12p4ypm-0"
})(function (_ref) {
  var $spacingSpace = _ref.$spacingSpace,
    _ref$$color = _ref.$color,
    $color = _ref$$color === void 0 ? defaultProps.color : _ref$$color,
    $colorEmphasis = _ref.$colorEmphasis,
    $customColor = _ref.$customColor,
    _ref$$shadow = _ref.$shadow,
    $shadow = _ref$$shadow === void 0 ? defaultProps.shadow : _ref$$shadow,
    $hasInvertedShadow = _ref.$hasInvertedShadow,
    _ref$$borderRadiusSiz = _ref.$borderRadiusSize,
    $borderRadiusSize = _ref$$borderRadiusSiz === void 0 ? defaultProps.borderRadiusSize : _ref$$borderRadiusSiz,
    $hasBorder = _ref.$hasBorder,
    $borderEmphasis = _ref.$borderEmphasis,
    $hasCenteredChildren = _ref.$hasCenteredChildren,
    $borderWidth = _ref.$borderWidth,
    $display = _ref.$display,
    $backgroundImage = _ref.$backgroundImage,
    $backgroundBlurUnit = _ref.$backgroundBlurUnit,
    theme = _ref.theme;
  var customColor = $customColor && getCustomColor($customColor);
  return css(["", ";display:", ";background:", ";", " ", " ", " ", ";", " ", ""], spacingStyles($spacingSpace), $display, customColor || getColor(theme, $color, "default", $colorEmphasis), $shadow !== "none" ? css(["box-shadow:", ";"], getBoxShadow(theme, $shadow, $hasInvertedShadow)) : null, $borderRadiusSize !== "none" ? borderRadiusStyles($borderRadiusSize, theme) : null, $hasBorder ? css(["border:", " solid ", ";"], unit($borderWidth), getBorderColor(theme, $color, $borderEmphasis || "low")) : null, $hasCenteredChildren ? css(["display:flex;flex-direction:column;align-items:center;justify-content:center;"]) : null, $backgroundImage ? css(["", ";background-repeat:no-repeat;"], getResponsiveBackgroundImageStyles($backgroundImage)) : null, $backgroundBlurUnit ? css(["backdrop-filter:blur(", ");-webkit-backdrop-filter:blur(", ");"], unit($backgroundBlurUnit), unit($backgroundBlurUnit)) : null);
});